import armStats from "../assets/images/content/arm-stats.jpg";

export const BONUS = [
  {
    id: "jeo",
    title: "JEO",
    blocks: [
      {
        t: "p",
        c: "Дуже просунута — і поки що погано задокументована — тема. Нижче наведено уривок обговорення в особистих повідомленнях, який пояснює саму ідею JEO (мовою оригіналу, без перекладу, щоб не втратити точність термінів).",
      },
      {
        t: "quote",
        lines: [
          "JEO — EO частини куба (рухи тільки на normal/inverse), що складається лише з рухів ⟨F B R2 U2 L2 D2⟩.",
          "Далі припускається, що є якісь рухи на normal, що ведуть до JZP на inverse.",
          "Виявляється, JZP на inverse існує тоді й лише тоді, коли обидва EO — R/L та U/D — на normal можна досягти рухами ⟨U D R L F2 B2⟩, що дає нам зручне правило.",
          "",
          "JEO має декілька цікавих властивостей.",
          "Головна з них — орієнтація кутів.",
          "Скажімо, ми хочемо відкидати кожен EO без RZP в ≤5 рухів.",
          "Тоді іноді можна відкинути перевірку JEO без світчу.",
          "Під час рухів ⟨F B R2 U2 L2 D2⟩ орієнтація деяких кутів не змінюється.",
          "Якщо на грані F або B є біла чи жовта наклейка, вона залишиться там і після завершення JEO.",
          "Це означає: якщо таких наклейок 5 або більше, гарантовано не буде 5-ходового RZP на U/D.",
          "Для швидкої перевірки можна використати NISS-розпізнавання.",
          "Достатньо подивитись на кількість зелених і синіх наклейок кутів на гранях U та D.",
          "",
          "Утім, нас завжди цікавлять одразу дві осі DR (U/D і R/L).",
          "Проблема в тому, що якщо на U/D з'являється більше 4 наклейок, на R/L їх з'являється менше 4 — тож перевірити варто.",
          "Кращий критерій поки не визначено.",
          "Здається, це тема, що потребує дослідження (перевірки всіх випадків) і спирається на ймовірність.",
          "Сподіваюсь, це може бути корисним.",
          "Можна також дивитись на ребра, але там усе трохи складніше.",
        ],
      },
    ],
  },
  {
    id: "jzp",
    title: "JZP",
    blocks: [
      {
        t: "p",
        c: "Ще один просунутий термін, тісно пов'язаний із JEO — і саме той, на який дає посилання розділ [Domino Reduction](/domino#dr) при виборі RZP за 6 рухів.",
      },
      {
        t: "quote",
        lines: [
          "Для JZP сетап DR має бути розв'язним без чверть-обертів на гранях, на яких ви вирішуєте DR.",
          "Наприклад, для 4e4c можна мати `B2 R2 U2 R`, але не `R2 U' R`.",
          "Вимоги: немає наклейок кутів U/D на R/L, немає ребер E-слайсу в M-слайсі, і парна кількість неорієнтованих кутів (для EO на F/B + DR на U/D).",
          "Властивість, що робить це корисним: наявність JZP на одній осі DR означає, що після світчу JZP буде і на іншій осі.",
        ],
      },
    ],
  },
  {
    id: "arm",
    title: "ARM",
    blocks: [
      {
        t: "p",
        c: "ARM — ще одна просунута техніка ухвалення рішень при роботі з парністю кутів у DR/HTR, тісно пов'язана з гіперпарітетом (див. ресурс «Using Hyper-Parity To Solve Corners In Domino Reduction» у розділі [HTR](/domino#htr)). Автор гайду лишив по темі лише довідкову таблицю ймовірностей для різних кутових підтипів — орієнтир, а не готовий рецепт:",
      },
      {
        t: "image",
        src: armStats,
        alt: "Таблиці статистики ARM для підтипів 4c4e, 4c6e, 4c2e, 3c2e, 2c0e, 3c2e(2), 7c8e, 8c8e",
        caption: "Довідкові таблиці ймовірностей ARM по кутових підтипах (з оригінального гайду).",
      },
    ],
  },
];
